<template>
  <div id="login" v-if="showLogin">
    <div class="login-wrap">
		<h2>麒麟软件账号登录</h2>
		<div v-if="ssoErrorMsg" class="sso-error-tip">
			{{ ssoErrorMsg }}
		</div>
		<ul class="login-ul">
			<li>
				<el-input class="input-box" size="medium" type="text" v-model="username" placeholder="邮件地址/手机号"/>
			</li>
			<li>
				<el-input class="input-box" size="medium"  show-password  type="password" v-model="password" placeholder="密码"/>
			</li>
			<li class="ub w100 ub-ac code-box">
				<div class="ub ub-f1">
					<el-input class="input-box" size="medium" style="width:100%;" type="text" v-model="code" placeholder="验证码"/>
				</div>
				<div class="code h100">
					<el-button style="width:100%;height:100%;" @click="sendVerificationCode" :disabled="countdown > 0">
						{{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
					</el-button>
				</div>
				
			</li>
		</ul>
		<el-button :loading="isSubmiting" :disabled="isSubmiting" class="login-btn" type="danger"  @click="toLoginBtn">{{ loginText }}</el-button>
		<div class="login-tips clearfix">
			<a :href="registerUrl" target="_blank">注册</a>
			<span class="login-line"></span>
			<a :href="passwordUrl"  target="_blank">忘记密码</a>
		</div>
	</div>
  </div>
</template>

<script>
import qs from 'qs'
import { post, ajaxParam, get } from '@/units/request.js'
import {encrypt} from '@/units/ras'

const isEmail = (s) => {
		var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    return regex.test(s);
	}
const isMobile = (s) => {
return /^1[0-9]{10}$/.test(s)
}
export default {
  name: 'login',
  data(){
	return {
		showLogin: false, // 麒麟ID V2.0直接跳转到麒麟ID登录页，论坛登录页表单隐藏
		ssoErrorMsg: '',
		loginText:'登 录',
		isSubmiting:false,
		username: '',   //登录用户名
		password: '', //密码
		code: '', //图形验证码
		imageCodeSrc: '', //图形验证码图片地址
		registerUrl: 'https://id.kylinos.cn/registered?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
		returnUrl: '',
		passwordUrl: 'https://id.kylinos.cn/find?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
		activityType: 1,
		activeInfo: {},
    	app_key:'',
    	response_type:'',
		kyId_uri: '',
    	redirect_uri:'',
		form: '0',
		countdown: 0, // 初始倒计时时间
        intervalId: null, // 存储interval的id
	}
  },
  watch: {
    $route: {
      async handler() {
        await this.loginCheck()
      },
      immediate: true
    }
  },
  beforeDestroy(){
	if(this.intervalId){
		clearInterval(this.intervalId);
		this.intervalId = null
	}
  },
  methods: {
  async loginCheck() {
      const routeQuery = this.$route.query || {};
      const keyCode = routeQuery.code || '';
      const ssoError = routeQuery.error || '';
      const ssoErrorCode = routeQuery.error_code || '';
      const redirectPath = routeQuery.redirect || '/home';
      const loginType = routeQuery.type || 'kylin_id'; // 默认麒麟ID登录
      console.log('loginCheck-routeQuery', routeQuery, 'code', keyCode, 'showLogin', this.showLogin);

      // type=pwd 时显示本地账号密码登录表单，不跳转麒麟ID OAuth
      if (loginType === 'pwd' && !keyCode) {
        this.showLogin = true;
        return;
      }else{
		this.showLogin = false;
	  }

      // prompt=none 无痕登录检测：麒麟ID未登录时返回 login_required，静默跳转首页
      if (ssoErrorCode === 'login_required') {
        console.log('麒麟ID未登录，静默返回首页');
        this.$router.replace('/home');
        return;
      }

      if (ssoErrorCode) {
		console.log('ssoErrorCode:', ssoErrorCode);
        const errorMsg = decodeURIComponent(ssoError);
        this.$message.error(errorMsg || '登录失败，请重试');
        this.$router.replace({ path: '/login', query: {} });
        return;
      }

      if (keyCode) {
        console.log('code存在，开始登录：',this.showLogin);
        let url = 'v1/user/ssoLogin';
        let param = {
          kyCode: keyCode
        };
        console.log('code存在，params：', param);

        try {
          const res = await post(url, qs.stringify(param))
          console.log('login request:', res);
          if (res.data.code == 200) {
            //存储登录信息
            localStorage.setItem('user', JSON.stringify(res.data.entity));
            localStorage.setItem('userId', res.data.entity.id);
            localStorage.setItem('token', res.data.entity.token);
            localStorage.setItem('uuid', res.data.entity.uuid);
            localStorage.setItem('isVisible', true);
            this.bus.$emit('resfreshheaPic')
            await this.$router.push({
              path: redirectPath
            })
          } else {
            this.$message.error(res.data.msg || '登录失败，请重试');
          }
        } catch (e) {
          console.log('登录请求失败', e);
          this.$message.error('登录请求失败，请重试');
        }
      } else {
        try {
		  console.log('code不存在，开始登录：',this.showLogin);
          await this.getSsoConfig();
          const params = {
            app_key: this.app_key || '',
            response_type: this.response_type || '',
            redirect_uri: this.redirect_uri || ''
          };
          const queryString = new URLSearchParams(params).toString();
          console.log('querString:', queryString)
          const fullUrl = `${this.kyId_uri}?${queryString}`;
          window.location.href = fullUrl;
        } catch (e) {
          console.log('获取SSO配置失败，显示本地登录页', e);
          this.$message.error('获取登录配置失败，请刷新页面重试');
        }
      }
    },
  async getSsoConfig(){
	// 
    // let param = {
    // }
    // ajaxParam(param)
    const res = await get('v1/user/ssoConfig',{})
    if(res.data.code==200){
      console.log('getSsoConfig:', res.data.entity)
      this.app_key = res.data.entity.app_key
      this.redirect_uri  = res.data.entity.redirect_uri
      this.response_type = res.data.entity.response_type
	  this.kyId_uri = res.data.entity.kyId_uri
    } else {
		console.log('获取SSO配置失败:',res.data)
      	this.$message.error(res.data.msg)
    }
  },
	startCountdown() {
        this.countdown = 60; // 假设倒计时60秒
        this.intervalId = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown -= 1;
          } else {
            clearInterval(this.intervalId);
          }
        }, 1000);
      },
  sendVerificationCode() {
		if(!this.username) {
			this.$message.error('用户名不能为空')
			return
		}
		if (!(isMobile(this.username)||isEmail(this.username))) {
			this.$message.error('邮件地址/手机号格式不正确')
			return 
		}
        // 开始倒计时
        this.startCountdown();
		this.getImageCode() 
      },
	toLoginBtn(){
		let username = this.username
		let password = this.password
		let code = this.code
		if(!username) {
			this.$message.error('用户名不能为空')
			return
		}
		if (!(isMobile(username)||isEmail(username))) {
			this.$message.error('邮件地址/手机号格式不正确')
			return 
		}
		if(!password) {
			this.$message.error('请输入您的密码')
			return
		}
		if(!code) {
			this.$message.error('请输入验证码')
			return
		}
		this.toLogin()
	},
	async toLogin(){
		// let url = 'v1/user/doLogin'
		let url = 'v1/user/idUserLogin'
		let param = {
			userName: this.username,
			password: encrypt(this.password),
			code: this.code,
			form:this.form
		}
		this.isSubmiting = true
		this.loginText = '登录中'
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			//存储登录信息
			localStorage.setItem('user',JSON.stringify(res.data.entity))
			localStorage.setItem('userId', res.data.entity.id)
			localStorage.setItem('token', res.data.entity.token)
			localStorage.setItem('uuid', res.data.entity.uuid)
			localStorage.setItem('isVisible',true)
			this.bus.$emit('resfreshheaPic')
			this.$router.go(-1)
		} else {
			this.isSubmiting = false
			this.loginText = '登 录'
			this.$message.error(res.data.msg)
		}
	},
	async getImageCode() {
		// let param = {}
		// let url = 'v1/user/getMCodeImage'
		
		let param = {
			userName:this.username
		}
		this.form = '0'
		let url = 'v1/user/getIdCode'
		const res = await post(url, param)
		if(res?.data?.code==='200'){
			this.form = res.data.entity.form
			this.$message.success(res.data.entity.message)
		}else{
			this.$message.error(res.data.message)
		}
		console.log(res,'0000000000')
		// this.$message.error('请输入图形验证码')
	},
	switchToKylinId() {
		this.$router.replace({ path: '/login', query: { type: 'kylin_id' } });
	},
	async getRedirectUrl() {
		let param = {
			code: 'QILIN-ID-REDIRECT-LOGIN'
		}
		const res = await post('/v1/sysConfig/getConfigByCode', qs.stringify(param))
		if(res.data.code==200) {
			this.returnUrl = res.data.entity.configValue
			this.registerUrl = this.registerUrl+ this.returnUrl
			this.passwordUrl = this.passwordUrl+ this.returnUrl
		}
	}
  },
}
</script>

<style lang="less" scoped>
	#login{
		background: #fff;
		overflow: hidden;
	}
	.login-wrap{
		width: 30%;
		margin: 60px auto 30px;
		h2{
			padding-bottom: 40px;
			font-size: 32px;
			line-height: 47px;
			font-weight: 400;
			text-align: center;
		}
		.sso-error-tip{
			background: #fef0f0;
			color: #f56c6c;
			padding: 12px 16px;
			border-radius: 4px;
			margin-bottom: 20px;
			font-size: 14px;
			text-align: center;
			border: 1px solid #fbc4c4;
		}
		.login-ul{
			li{
				margin-top: 20px;
				border-radius: 6px;
				background:#f7f7f7;
				padding-left: 40px;
				height: 48px;
				position: relative;
				box-sizing: border-box;
				&.code-box{
					position: relative;
					.code{
						width:130px;
						position: absolute;
						right:0;
						top:0;
					}
				}
				/deep/ .el-input--medium .el-input__inner {
						width: 100%;
					    height: 48px;
						font-size: 14px;
						line-height: 48px;
						color: #333;
						background: none;
						border-color:rgba(0,0,0,0);
						
				}
				// .input-box{

				// 	width: 100%;
				//     height: 100%;
				// 	font-size: 14px;
				// 	line-height: 48px;
				// 	color: #333;
				// 	background: none
				// }
				.code-btn{
					position: absolute;
					right:0;
					top:0;
					height: 48px;
					right: 20px;
					line-height: 48px;
				}
			}
		}
		
		.login-btn{
			display: block;
			width: 100%;
			height: 48px;
			margin:60px auto 30px;
			background: #DE0515;
			border-color: #DE0515;
			border-radius: 6px;
			text-align: center;
			color:#fff;
			line-height: 48px;
			font-size: 23px;
			transition: all .3s;
			&:hover{
				background: #f78989;
				border-color: #f78989;
			}
			&.is-disabled{
				background: #f78989;
				border-color: #f78989;
			}
			
		}
	
		.login-tips{
			width:130px;
			margin: 0 auto;
			text-align: center;
			a{
				float:left;
				height:20px;
				color:#007DFF;
				line-height: 18px;
				&:hover{
					opacity: .6;
				}
			}
			.login-line{
				float: left;
				width: 1px;
				height: 18px;
				margin: 0 20px;
				background: #e5e5e5;
			}
		}
		.switch-login{
			text-align: center;
			margin-top: 20px;
			a{
				color: #007DFF;
				font-size: 14px;
				&:hover{ opacity: .6; }
			}
		}
	}
</style>
